import { RouteConfig } from '/@/modules/core/app/helpers/RouteConfig';
import { getters } from '/@/modules/core/app/helpers/store';

export class EstateBankingRequestOverviewRouteConfig extends RouteConfig {
  /**
   * @returns {boolean}
   */
  canAccessRoute() {
    return getters.auth.getUser().permission.canManageEstateBankingRequest;
  }
}
